var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTracklogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E62F4D;}\r\n\t.st1{opacity:7.000000e-02;fill:#2D2E2D;enable-background:new    ;}\r\n\t.st2{fill:#454444;}\r\n\t.st3{fill:#FFFFFF;}\r\n\t.st4{fill:#181C2E;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M99.3,25.2v49.6c0,1.4-0.1,2.8-0.3,4.1c-0.3,1.5-0.6,2.9-1.2,4.3c-2.5,6.8-7.9,12.2-14.7,14.6 c-2.7,1-5.5,1.5-8.3,1.4H24.7C16,99.2,8,94.4,3.8,86.8c-2-3.6-3.1-7.7-3.1-11.8V25.2c0-1.2,0.1-2.3,0.2-3.4c0.1-0.7,0.2-1.3,0.4-2 c0.7-3.2,2.1-6.3,4.1-8.9c1.7-2.3,3.8-4.4,6.2-6c1.6-1.1,3.3-1.9,5.1-2.6c1.3-0.5,2.6-0.9,4-1.1c1.5-0.3,3-0.4,4.6-0.4h49.6 c2.8,0,5.7,0.5,8.3,1.5c0.8,0.3,1.6,0.6,2.4,1c3.9,1.9,7.2,4.8,9.6,8.3c0.5,0.8,1,1.6,1.4,2.4c0.8,1.5,1.4,3.1,1.8,4.7 c0.3,1.1,0.6,2.3,0.7,3.5C99.3,23.1,99.3,24.1,99.3,25.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.3,33l-11.3-6.7l5.3-7.8l5.8,3.5c-0.2-1.2-0.4-2.3-0.7-3.4l-3.6-2.1l1.7-2.5c-0.4-0.8-0.9-1.6-1.4-2.4 l-2.5,3.7L82.2,8.9l3.3-5.8c-0.8-0.4-1.6-0.7-2.4-1L80,7.6l-8.9-5.3l1-1.6H69L68.9,1l-0.5-0.3h-5.1l27.8,16.5L85.8,25L54.5,6.3 l3.4-5.7h-3L52.2,5l-7.3-4.3H34.8l0.8,0.4l4.6,2.7l-3.8,7.5l-0.6-0.4l-6.9,10.7L13.6,13l7-11.9c-1.4,0.3-2.7,0.6-4,1.1l0.2,0.1 l-12,20.3l-3.3-1.9l0.4-0.7l-0.6-0.4c-0.2,0.7-0.3,1.3-0.4,2L1,21.5l3.3,1.8l-3.7,6.3v5.1l5.5-9.3l8.1,4.7L0.7,54.8v5.3l9.9-17.9 l8.6,4.8L8.4,65l-7.8-4.6v3l6.4,3.8L2,75.8L0.7,75c0,4.1,1.1,8.2,3.1,11.8C9.4,90,15,93.3,20.4,96.4l-1.1,2.2 c1.8,0.5,3.6,0.7,5.4,0.7l0.1-0.3l0.5,0.3h16.9L39,97.4l5.2-8.7L62,99.3h5L45.6,86.6l5-8.3l24.2,15.2L71,99.3h3l3-4.5l0.2,0.1 l3.2,3.8c0.9-0.2,1.8-0.5,2.7-0.8l-4.2-5l-0.2-0.1l-7.2-4.5L82,70.1l11.5,8.2l4.3,4.9c0.5-1.4,0.9-2.9,1.2-4.3l-0.8,0.9L96,77.2 l3.3-5v-1.6l-3.9,5.9l-0.2-0.3l-11.9-8.5l4.8-8.3L99.3,66v-1l-10.8-6.2l5.5-9.5l5.3,3.1v-3l-4-2.3l4-7L99.3,33L99.3,33z M40.9,4.3 l25,14.8L60.7,28l-9-5l1-1.4L37,11.7L40.9,4.3z M49.5,47.4l-10.1-5.8l11.9-18l9,5.1l-6.2,10.7l0,0L49.5,47.4z M50.4,51L74,64.6 l-4.7,8.6L45.9,58.8L50.4,51z M62.3,30.4l23.8,13.9l-5.2,8.9L57,39.6L62.3,30.4z M36.5,14.4L48.6,22c0,0.1,0.1,0.2,0.2,0.3l0.2,0.1 l-5.1,7.8L31,22.8L36.5,14.4z M7.5,23.1l4.7-8l30.2,17.1l-5.3,8L7.5,23.1z M11.8,39.9l4.8-8.6l31.6,18.3l-4.5,7.8L11.8,39.9z  M21.5,48.2l20.9,11.5l-11,18.9L10.6,66.3L21.5,48.2z M25.3,89.3c-7-4.1-14.2-8.3-21-12.2l5.1-8.5l20.8,12.4L25.3,89.3z M36.8,96.1 c-3-1.8-6.1-3.6-9.3-5.5l11.4-19.7l9.5,6L36.8,96.1z M69.3,86.9L40.2,68.7l4.4-7.6l25.6,15.8l0.3-0.5l3.2,3L69.3,86.9z M74.1,78.5 l-3.2-3l5.5-10l3.9,2.4L74.1,78.5z M80.7,67.1l-3.8-2.4l0.6-1.1L51.7,48.7l4-7l26.2,14.9l0.3-0.5l3.7,2.1L80.7,67.1z M86.3,57.5 l-3.7-2.1l5.9-10.1l3.7,2L86.3,57.5z M92.6,46.6l-3.7-2l0.7-1.2L63.6,28.2l4.5-7.7L97.6,38L92.6,46.6z M11.5,4.8 c-2.4,1.6-4.5,3.7-6.2,6l1.7,1.1L11.5,4.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.3,
    y: 48.8,
    className: "st2",
    width: 1.1,
    height: 10.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M77.9,25.9v5.6H58.4v51.2H41.3V31.5H29c-3.9,0-7.1-3.2-7.1-7.1v-6.6h47.9C74.2,17.8,77.9,21.4,77.9,25.9 C77.9,25.9,77.9,25.9,77.9,25.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.8,
    y: 35.8,
    className: "st4",
    width: 2.3,
    height: 16.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.8,
    y: 60.4,
    className: "st4",
    width: 2.3,
    height: 16.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 23.6,
    className: "st4",
    width: 16.3,
    height: 2.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.5,
    y: 23.6,
    className: "st4",
    width: 16.3,
    height: 2.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTracklogo);
export default __webpack_public_path__ + "static/media/tracklogo.071e594331ab3ea473570e3bafb7d7a3.svg";
export { ForwardRef as ReactComponent };